import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ATM_CODES, ITransactionByDigitizedCard } from '@/features/cards/store/models/card.model';
import { DigitizedCard } from '@/features/cards/components/CardTransactionsTable/DigitizedCard';
import {
  getCardTransactionConfigKey,
  TCardTransactionColumnSetting,
} from '@/features/cards/store/models/card-transactions.model';

export interface IPaymenModeCellProps {
  transaction: ITransactionByDigitizedCard;
  config?: TCardTransactionColumnSetting;
  shouldShowId?: boolean;
}

export function PaymentModeCell({ transaction, config, shouldShowId = true }: IPaymenModeCellProps) {
  const { t } = useTranslation();

  const paymentMode = useMemo(() => {
    if (ATM_CODES.includes(Number(transaction.mccCode))) {
      return 'atm';
    }

    if (transaction.is3DS) {
      return 'cardPayment3DS';
    }
    return 'cardPayment';
  }, [transaction]);

  const isDigitalCard = Number(transaction?.cardDigitalizationExternalId) > 0;

  return (
    <div className="flex flex-col items-start w-fit gap-2">
      {isDigitalCard ? (
        <DigitizedCard transaction={transaction} />
      ) : (
        <div className="flex gap-2 items-center bg-tag-gray rounded-100 px-3 py-2 text-nowrap">
          <span className="bg-tag-gray text-tag-gray text-sm font-bold">
            {t(`pages.currentProfiles.cards.transactions.table.${paymentMode}`)}
          </span>
        </div>
      )}
      {getCardTransactionConfigKey(config, 'cardtransactionId') && shouldShowId && (
        <div className="flex items-center text-tertiary text-sm gap-3 text-nowrap">
          <span className="font-light">
            {t('pages.currentProfiles.cards.transactions.table.headers.cardtransactionId')}
          </span>
          <span className="text-helper">{transaction.cardtransactionId}</span>
        </div>
      )}
    </div>
  );
}
